import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  standalone: false,
  selector: 'app-no-gps-points-dialog',
  template: `
    <div style='z-index:20000'>
      <mat-dialog-content>
        {{ data?.message }}
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-button mat-dialog-close>OK</button>
      </mat-dialog-actions>
    </div>
  `
})
export class NoGpsPointsDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

}